// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"505e2142","268":"1f1a6ad0","422":"5e26cb31","482":"d2850ba4","486":"69f36627","589":"70d5fe9f","899":"5a349d89"}[chunkId] + ".chunk.css";
};